import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

interface IProps {
  bgType?: 'white' | 'black' | string;
}

const ShortformItemSkeleton = ({ bgType = 'black' }: IProps) => (
  <S.Box className="shortform-item-skeleton" $bgType={bgType}>
    <div className="user-info">
      <Skeleton className="user-img" />
      <Skeleton className="user-name" />
    </div>
    <div className="shortform-info">
      <Skeleton className="text text01" />
      <Skeleton className="text text02" />
      <div className="product-list">
        <Skeleton className="product-item" />
        <Skeleton className="product-item" />
        <Skeleton className="product-item" />
      </div>
    </div>
  </S.Box>
);

export default ShortformItemSkeleton;
